import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonLoading,
  IonPage,
  IonTitle,
  IonToolbar
} from '@ionic/react'
import React, { useState } from 'react'
import { PrismicBody } from '../components/prismic/body'
import { PrismicClient, PrismicDocument } from '../prismic'

const Terms: React.FC = () => {
  const [showLoading, setShowLoading] = useState(true);
  const [doc, setDocData] = React.useState<PrismicDocument>()

  React.useEffect(() => {
    const fetchData = async () => {
      setDocData(await PrismicClient.getByUID('web-page', 'agb', {}))
      setShowLoading(false)
    }
    void fetchData()
  }, [])

  return (
    <IonPage color={'primary'}>
      <IonHeader>
        <IonToolbar color={'primary'}>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/home" />
          </IonButtons>
          <IonTitle>Eigenheim Versicherung</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent
        className="ion-padding"
        color={'background'}
      >
        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={'Seite wird geladen...'}
        />

        {doc && <h1 style={{ textAlign: doc?.data.text_align }}>{doc?.data.title}</h1>}
        {doc && <PrismicBody data={doc?.data.body} />}
      </IonContent>
    </IonPage>
  )
}

export default Terms
